import React from 'react';

const EditUser = React.lazy(() => import('./EditUser'));
const EditNewUser = React.lazy(() => import('./EditNewUser'));
const CreateUser = React.lazy(() => import('./CreateUser'));
const ManageUsers = React.lazy(() => import('./ManageUsers'));
const DuplicateUser = React.lazy(() => import('./DuplicateUser'));
const CreateUserNew = React.lazy(() => import('./CreateUserNew'));

export {
  ManageUsers,
  EditUser,
  EditNewUser,
  CreateUser,
  DuplicateUser,
  CreateUserNew,
};
